import React from "react";
import "./HeroSection.css";
import Button from "./Button";
import "../App.css";
function HeroSection() {
  return (
    <div className="hero-container">
      <video
        autoPlay
        loop
        muted
        src="https://storage.coverr.co/videos/pgOMUjyJgnBg5u01tfrUPjU86nHCVHcWh?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6IjM4Q0MzQTdGQTlGMUVDNDgxQjk3IiwiaWF0IjoxNjM1NzAwMTQ4fQ.dWBJreic_INiSVL8b076JgyOYoRPWELTiFG2jBrwFqw"
      ></video>
      <h1>ADVENTURE AWAITS</h1>
      <p>What are you waiting for ?</p>
      <div className="hero-btns">
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
        >
          GET STARTED
        </Button>
        <Button
          className="btns"
          buttonStyle="btn--primary"
          buttonSize="btn--large"
        >
          WATCH TRAILER <i className="far fa-play-circle"></i>
        </Button>
      </div>
    </div>
  );
}

export default HeroSection;
